
define(
	'Code25.CaterpartsGlobal.PDPInformation'
	, [
		'Application', 'Backbone.View', 'Utils', 'Configuration', 'Tools'
	]
	, function (
		Application, BackboneView, Utils, Configuration, Tools
	) {
		'use strict';

		return {
			mount: function (container) {

				var layout = container.getComponent('Layout');
				if (layout) {
					if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
						var ProductDetails_Information_View = require("ProductDetails.Information.View");

						if (ProductDetails_Information_View) {

							ProductDetails_Information_View.prototype.computeDetailsArea = function () {
								var self = this;
								var details = [];
								// console.log(this);
								//var _sku=this.model.get("item").get("_sku");
								if (Configuration.Configuration) {
									Configuration = Configuration.Configuration;
								}

								_.each(Configuration.get('productDetailsInformation', []), function (item_information) {
									var content = '';

									if (item_information.contentFromKey) {
										content = self.model.get('item').get(item_information.contentFromKey);
									}

									if (content && $.trim(content)) {
										//console.log(item_information.contentFromKey);
										if (item_information.contentFromKey == "custitem_c25_search_models"||item_information.contentFromKey == "custitem_c25_search_oems") {
											try {
												content = content || "";
												if(content){
													var data=JSON.parse(content);
													var models=[];
													for(var i in data){
														models.push(i);
													}
													models.sort(function(A,B){
														return A.localeCompare(B);
													});
												}
												var body="",names;
												for(var i=0;i<models.length;i++){
													if(i>0){
														body+="<br />";
													}
													body+="<h4>"+models[i]+"</h4>";
													names=data[models[i]];
													names.sort(function(A,B){
														return A.localeCompare(B);
													});
													
													body+="<div class=\"info-columns-sm\">"+names.join("<br />")+"</div>";
												}
												content=body;
												// if (content.length < 600) {
												// 	content = "<div class=\"info-column\">" + content + "</div>";
												// } else {
												// 	content = "<div class=\"info-columns\">" + content + "</div>";
												// }
											} catch (err) {
												console.log(err);
											}
										}else if(item_information.contentFromKey == "custitem_mh_techspecs" ||item_information.contentFromKey == "custitem_specifications"){
											try {
												content=Tools.cleanHtml(content||"");
											} catch (err) {
												console.log(err);
											}
										}

										// @class ProductDetails.Information.DataContainer
										details.push({
											// @property {String} name
											name: item_information.name,
											// @property {String} content Any string and event valid HTML is allowed
											content: content,
											// @property {String} itemprop
											itemprop: item_information.itemprop
										});
										// @class ProductDetails.Information.View
									}

								});

								return details;
							}
						}

					}
				}

			}
		}
	}
);
